import { render, staticRenderFns } from "./sidelist.vue?vue&type=template&id=eb38f7bc&scoped=true"
import script from "./sidelist.vue?vue&type=script&lang=js"
export * from "./sidelist.vue?vue&type=script&lang=js"
import style0 from "./sidelist.vue?vue&type=style&index=0&id=eb38f7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb38f7bc",
  null
  
)

export default component.exports